import React, { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import clsx from 'clsx';
import moment from 'moment';
import PropTypes from 'prop-types';
import _ from 'underscore';
import { makeStyles } from '@mui/styles';
import { Card, CardContent,	TextField, Grid, IconButton, colors, Tooltip } from '@mui/material';
import Create from '@mui/icons-material/Create';
import EditIcon from '@mui/icons-material/EditOutlined';
import CancelIcon from '@mui/icons-material/Cancel';
import { Label, DataTable, Header, Alert } from 'components';

const useStyles = makeStyles((theme) => ({
	root: {},
	content: {
		padding: 0,
	},
	inner: {
		minWidth: 700,
	},
	nameCell: {
		display: 'flex',
		alignItems: 'center',
	},
	avatar: {
		height: 42,
		width: 42,
		marginRight: theme.spacing(1),
	},
	actions: {
		padding: theme.spacing(1),
		justifyContent: 'flex-end',
	},
	primaryButton: {
		color: theme.palette.primary.main
	},
	errorButton: {
		color: theme.palette.error.main
	},
	infoButton: {
		color: theme.palette.info.main
	}
}));

const IncidentTable = (props) => {
	const { className, data, identifier, title, customColumns, onDeleteClick, onEditClick, ...rest } = props;
	const classes = useStyles();

	const _renderActions = (tableMeta) => {
		const { rowData } = tableMeta;
		return (
			<>
				<Tooltip title="Edit">
					<IconButton edge="end" size="small" className={classes.primaryButton} onClick={() => onEditClick(rowData)}>
						<EditIcon />
					</IconButton>
				</Tooltip>
				<Tooltip title="Remove">
					<IconButton edge="end" size="small" className={classes.errorButton} onClick={() => onDeleteClick(rowData)}>
						<CancelIcon />
					</IconButton>
				</Tooltip>
			</>
		);
	};

	const _getTableColumns = () => (
		[
			{
				name: 'id',
				label: 'Id',
				options: {
					display: false,
					filter: false,
					viewColumns: false,
					filterType: 'textField',
				}
			},
			...customColumns,
			{
				name: 'action',
				label: 'Actions',
				options: {
					filter: false,
					sort: false,
					viewColumns: false,
					empty: true,
					print: false,
					download: false,
					customBodyRender: (value, tableMeta, updateValue) => _renderActions(tableMeta)
				}
			}
		]
	);

	return (
		<div {...rest} className={clsx(classes.root, className)}>
			<DataTable
				id={identifier}
				title={title}
				data={data}
				columns={_getTableColumns()}
				rowsPerPage={10}
				tableBodyMaxHeight="30em"
				tableBodyCellMaxWidth="250"
			/>
		</div>
	);
};

IncidentTable.propTypes = {
	className: PropTypes.string,
	data: PropTypes.array.isRequired,
	identifier: PropTypes.string,
	title: PropTypes.string,
	customColumns: PropTypes.array,
	onDeleteClick: PropTypes.func,
	onEditClick: PropTypes.func,
};

export default IncidentTable;
